export const updateURLSearchParams = (form) => {
    const formData = new FormData(form);
    const params = new URLSearchParams(formData);
    const url = new URL(window.location);
    url.search = "";
    params.forEach((value, key) => {
        if (value) url.searchParams.append(key, value);
    });
    history.pushState({}, "", url);
};

export const appendFormData = (data, obj, parentKey = "") => {
    Object.keys(obj).forEach((key) => {
        const fullKey = parentKey ? `${parentKey}[${key}]` : key;
        if (typeof obj[key] === "object" && obj[key] !== null) {
            appendFormData(data, obj[key], fullKey);
        } else {
            data.append(fullKey, obj[key]);
        }
    });
};

export const getCSSVar = (name, asNumber, element = document.documentElement) => {
    const value = getComputedStyle(element).getPropertyValue(name).trim();
    return asNumber ? parseFloat(value) : value;
};
